import { Select as MantineSelect } from '@mantine/core';
import React, { useCallback } from 'react';
import { useAppDispatch } from '@hooks/useDispatch';
import { setEditingCell } from '@store/Spreadsheet/editingSlice';
import { updateRow } from '@store/Spreadsheet/rowsSlice';
import { CommonCellProps } from '../Cell';
import classes from '../Cell.module.css';
import { IconSelector } from '@tabler/icons-react';
import { cellValueChanged } from '@store/Spreadsheet/cellChangesSlice';


export default function CellSelect({ rowId, columnId, currentRow, isEditing, value, options = []}: CommonCellProps ) {
  const dispatch = useAppDispatch();

  const commitEdit = useCallback(( newValue: string ) => {
    if ( !currentRow ) return;
    const newValues = { ...currentRow.values, [columnId]: newValue };

    dispatch( updateRow({ id: rowId, changes: { values: newValues }}));
    dispatch( cellValueChanged({ rowId, columnId, oldValue: currentRow.values[columnId],newValue: newValue }));
    dispatch( setEditingCell( null ));
  }, [ dispatch, rowId, columnId, currentRow ]);

  const cancelEdit = useCallback(() => {
    dispatch( setEditingCell( null ));
  }, [dispatch]);

  const handleKeyDown = useCallback(( e: React.KeyboardEvent<HTMLInputElement> ) => {
      if ( !isEditing ) return;
      if ( e.key === 'Escape' ) {
        cancelEdit();
      }
    }, [ isEditing, cancelEdit ]);


  if ( !isEditing ) {
    return <span className={classes.cellSelectValueWrapper}>
            <span className={classes.cellValue}>{value}</span>
            <IconSelector stroke={1} className={classes.cellSelectValueIcon} />
          </span>;
  }

  return (
    <MantineSelect
      className={classes.cellSelectInput}
      value={value}
      onChange={( newValue ) => newValue && commitEdit( newValue )}
      onBlur={cancelEdit}
      onKeyDown={handleKeyDown}
      autoFocus
      data={options || []}
      checkIconPosition="right"
      variant="unstyled"
      styles={{
       root: { height: '29.19px', display: 'flex', alignItems: 'center', width: '100%' },
       wrapper: { height: '29.19px', display: 'flex', alignItems: 'center', width: '100%' },
       input: { height: '29.19px', lineHeight: '29.19px', fontSize: '13px', padding: '0 7px', display: 'flex', alignItems: 'center', width: '100%' },
       dropdown: { boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.2)' },
       option: { fontSize: '13px' }
      }}
      comboboxProps={{ position: 'bottom', middlewares: { flip: false, shift: false }, offset: 0 }}
      dropdownOpened={true}
    />
  );
}